module.exports = __webpack_public_path__ + "img/Site_matching_300px.14aa91ba.png";